import type { ReactNode } from "react"

import { cn } from "@productlane/lib/src/cn"

interface Props {
	title: string
	description?: ReactNode
	action?: ReactNode
	className?: string
}

export const SettingsSection = ({
	title,
	description,
	action,
	className,
}: Props) => {
	return (
		<div className={cn("mt-8 flex items-center justify-between", className)}>
			<div>
				<div className="text-sm font-medium">{title}</div>
				{description && (
					<p className="mt-1 text-xs text-secondary">{description}</p>
				)}
			</div>
			{action}
		</div>
	)
}
